import * as React from 'react';
import { SVGProps } from 'react';
import { SvgIcon } from '@mui/material';

export const SvgActiveEnvelope = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="64"
        width="65"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        viewBox="0 0 65 64"
    >
        <rect
            fill="#DBD6FF"
            height="64.0001"
            rx="32"
            width="64.0001"
            x="0.609863"
        />
        <path
            d="M12.6104 25.889L29.8029 12.7386C30.975 11.843 32.5886 11.7997 33.8063 12.6339L52.3794 25L52.3794 49L13.0974 49.8103L12.6104 25.889Z"
            fill="white"
        />
        <path
            d="M47.77 36.5644L18.4796 38.3559L17.2278 17.8898C17.1559 16.7138 18.0509 15.7022 19.227 15.6302L44.2587 14.0992C45.4347 14.0273 46.4463 14.9223 46.5183 16.0983L47.77 36.5644Z"
            fill="#715AFF"
        />
        <path
            d="M32.6855 34.2977L33.8843 34.2453L33.822 32.8181C36.5937 32.5446 38.0802 30.7828 37.9871 28.6515C37.8832 26.2728 35.7775 25.6403 34.543 25.3129L33.4797 24.978L33.3551 22.1235C34.1072 22.3195 34.7419 22.8828 35.0399 23.5943L37.2769 22.429C36.8754 21.0928 35.3884 19.785 33.2462 19.6307L33.1864 18.2606L31.9876 18.3129L32.0466 19.664C29.7904 19.9532 28.0465 21.4974 28.1446 23.7428C28.2484 26.1215 30.5702 26.8972 31.8229 27.2047L32.3822 27.3519L32.5127 30.3395C31.6671 30.1858 30.8992 29.6283 30.4687 28.5031L28.0091 29.3732C28.6532 31.4613 30.3288 32.7228 32.6223 32.8514L32.6855 34.2977ZM30.9294 23.3353C30.902 22.7073 31.3016 22.2513 32.1529 22.0998L32.2626 24.6117C31.4881 24.3404 30.9594 24.0203 30.9294 23.3353ZM33.714 30.3443L33.5969 27.6611C34.4466 27.91 35.0325 28.2276 35.0657 28.9888C35.0956 29.6739 34.5265 30.1754 33.714 30.3443Z"
            fill="#FED05D"
        />
        <path
            d="M12.6099 25.8895L32.8328 39.6874L12.8794 51.0001L12.6099 25.8895Z"
            fill="#EEECFF"
        />
        <path
            d="M52.3794 25L32.0566 40.0108L52.3794 50.5L52.3794 25Z"
            fill="#EEECFF"
        />
        <path
            d="M52.3794 50.5L34.7006 37.7306C33.4941 36.8833 31.88 36.9064 30.6989 37.7878L12.8794 51L52.3794 50.5Z"
            fill="#DAD7D7"
        />
    </svg>
);

export const ActiveEnvelopeIcon = ({
    fontSize = 'inherit',
    color = 'inherit',
    ...props
}: React.ComponentProps<typeof SvgIcon>) => (
    <SvgIcon
        {...props}
        color={color}
        component={SvgActiveEnvelope}
        fontSize={fontSize}
    />
);
